<span>
  <button class="btn-xs bdr-rad-15 mr-2 mb-2" *ngFor="let row of rows;" (click)="toggleSelection(row)" [ngClass]="{'btn-primary': row.selected, 'btn-primary-outline': !row.selected }">{{row.team.get("name")}}</button></span>